/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';
import { TopBannerState } from './types';

export const topBannerData = (state: { topBanner: TopBannerState }): TopBannerState =>
  state.topBanner;

export const getPdpBannerData = createSelector(
  [topBannerData],
  (data): object => data.pdpTopBanner
);

export const getPlpBannerData = createSelector(
  [topBannerData],
  (data): object => data.plpTopBanner
);

export const getWishlistBannerData = createSelector(
  [topBannerData],
  (data): object => data.wishlistTopBanner
);

export const getCouponLoggedInTopBanner = createSelector(
  [topBannerData],
  (data): object => data.couponLoggedInTopBanner
);

export const getHybridPDPTopBanner = createSelector(
  [topBannerData],
  (data): object => data.hybridPDPTopBanner
);
